import React from 'react';
import styled, { StylesProps } from '../../../../../lib/styles';
import { compose, withState, withProps } from 'recompose';
import Spacer from '../../../../../components/presentational/Spacer';
import Hero from '../../../../../components/presentational/Hero';
import Button from '../../../../../components/presentational/Button';
import TypeformEmbed from '../../../../../components/presentational/TypeformEmbed';
import Typeahead from './Typeahead';
import { withQuery } from '../../../../../lib/stringUtils';

import { getAgentSelectAddresses } from '../../../api';

import agentSelectBlockStyles from './AgentSelectBlock_styles';

export interface AgentSelectBlockData {
  type: 'agent_select_block';
  backgroundImage?: string;
  title: string;
  subtitle?: string;
  description?: string;
  formURL: string;
}

interface AgentSelectBlockProps {
  address: string;
  validAddress: boolean;
  typeformActive: boolean;
  setAddress: (address: string) => any;
  setValidAddress: (valid: boolean) => any;
  onSuggest: (search) => any;
  onSubmit: () => any;
  block: AgentSelectBlockData;
}

const AgentSelectBlock = ({
  address,
  validAddress,
  setAddress,
  setValidAddress,
  typeformActive,
  onSuggest,
  block: { title, subtitle, description, formURL, backgroundImage },
  onSubmit,
  styles,
}: AgentSelectBlockProps & StylesProps<typeof agentSelectBlockStyles>) => (
  <>
    <div className={styles.container}>
      <Spacer width={1160} space={['m', 'l']}>
        <Hero
          title={title}
          subtitle={subtitle}
          description={description}
          imageURL={backgroundImage}
          terms={
            'By filling out this form you agree to be contacted by Agent Select and Starts at 60.'
          }
        >
          <form
            className={styles.form}
            onSubmit={event => {
              event.preventDefault();
              onSubmit();

              return false;
            }}
          >
            <Typeahead
              className={styles.typeahead}
              size={'l'}
              value={address}
              placeholder={'Enter your address...'}
              onChange={(_, value, valid) => {
                setAddress(value);
                setValidAddress(valid);
              }}
              onSuggest={onSuggest}
            />

            <Button
              type={'submit'}
              color={'secondary'}
              disabled={!validAddress || typeformActive}
            >
              Continue
            </Button>
          </form>
        </Hero>
      </Spacer>
    </div>

    {typeformActive && (
      <TypeformEmbed url={withQuery(formURL, { address })} autoOpen />
    )}
  </>
);

export default compose(
  withState('address', 'setAddress', ''),
  withState('validAddress', 'setValidAddress', false),
  withState('typeformActive', 'setTypeformActive', false),
  withProps(({ typeformActive, validAddress, setTypeformActive }) => ({
    onSubmit: () => {
      if (!validAddress || typeformActive) return;

      setTypeformActive(true);
    },

    onSuggest: search =>
      getAgentSelectAddresses(search)
        .catch(async () => [])
        .then(async (addresses: string[]) =>
          addresses.map(address => ({
            label: address,
            value: address,
          }))
        ),
  })),
  styled(agentSelectBlockStyles)
)(AgentSelectBlock);
